var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-routes project-roles"},[_c('bread-icon',{staticClass:"icon"}),_c('trim-item',{staticClass:"name",attrs:{"string":_vm.link.name,"width":25}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }